import { Link } from '@epo/epods-react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutPage = () => {
    const [t] = useTranslation();
    return (
        <div>
            <br />
            <div className="mb-s">{t('ABOUT_PAGE::1ST_NOTICE_PARAGRAPH')}</div>
            <div className="mb-s">{t('ABOUT_PAGE::2ND_NOTICE_PARAGRAPH')}</div>
            <div className="mb-s">{t('ABOUT_PAGE::3ND_NOTICE_PARAGRAPH')}</div>
            <div className="mb-s">
                <a href={t('ABOUT_PAGE::MORE_LINK_URL')} target="_blank" rel="noopener noreferrer">
                    {t('ABOUT_PAGE::MORE_LINK_TEXT')}
                </a>
            </div>
            <div className="mb-s">
                {t('ABOUT_PAGE::4ND_NOTICE_PARAGRAPH')}{' '}
                <a href={t('ABOUT_PAGE::CONTACT_LINK_URL')} target="_blank" rel="noopener noreferrer">
                    {t('ABOUT_PAGE::CONTACT_LINK_TEXT')}
                </a>
            </div>

            <div>
                <div>{t('ABOUT_PAGE::EPO')}</div>
                <div>
                    <Link
                        href="https://www.epo.org"
                    >
                        www.epo.org{' '}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;
